import React, { useState, Fragment, useRef } from "react";
import { BryntumCalendar } from "@bryntum/calendar-react";
import { DateHelper, LocaleManager } from '@bryntum/calendar/calendar.umd';
import { actionEventRender } from "../../helpers/event.helper";
import moment from 'moment';
import EmptyBooking from "./EmptyBooking"
import Event from "./Event"

import "@bryntum/calendar/calendar.material.css";
import "./Calendar.scss";


const CalendarBryntum = (props, ref) => {

  const locale = {
    DateHelper: {
      locale: 'fr-FR',
      weekStartDay: moment().isoWeekday(),
    }
  }

  //console.log(moment().isoWeekday());

  LocaleManager.extendLocale('En', {
    locale: locale,
    DateHelper: {
      locale: 'fr-FR',
      weekStartDay: moment().isoWeekday(),
    },
    Sidebar: {
      'Filter events': 'Rechercher ...'
    }
  });

  //LocaleManager.applyLocale('Fr');

  const [view, setView] = useState('week');
  const [isLoading, setIsLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date(2020, 11, 7));

  const refresh = () => {
    console.log('refresh');
    //calendar.current.calendarInstance.crudManager.transport.load.url = `/data-${room}-refresh.json`;
    //calendar.current.calendarInstance.crudManager.load().then(
    //    () => calendar.current.calendarInstance.activeView.refresh()
    //);
  }

  var sidebar = props.hideSidebar ? false : { collapsed: props.collapsed };
  var toolbar = props.hideToolbar ? false : { show: true };

  var eventFilter = () => (eventRecord) => {

    const endDate = getEndDate(eventRecord);

    if (props.filters) {
      return endDate > new Date() && (
        (!props.filters.includeRooms && !props.filters.excludeRooms) ||
        (props.filters.includeRooms && props.filters.includeRooms.includes(eventRecord.data.room)) ||
        (props.filters.excludeRooms && !props.filters.excludeRooms.includes(eventRecord.data.room))
      ) && (
          (!props.filters.includeDisciplines && !props.filters.excludeDisciplines) ||
          (props.filters.includeDisciplines && props.filters.includeDisciplines.includes(eventRecord.data.resourceId + "")) ||
          (props.filters.excludeDisciplines && !props.filters.excludeDisciplines.includes(eventRecord.data.resourceId + ""))
        );
    }

    return endDate > new Date();
  };

  var headRenderEvent = (eventRecord) => {
    return `<div className="b-event-header">
                    <div className="b-event-time">
                        ${DateHelper.format(eventRecord.startDate, 'HH:mm')} -
                        ${DateHelper.format(getEndDate(eventRecord), 'HH:mm')}
                    </div>
                </div>`;
  }

  var descriptionRender = (activeView) => {
    const
      //sd = moment(activeView.startDate).add(1, 'd').format('DD/MM'),
      sd = moment(activeView.startDate).format('DD/MM'),
      ed = moment(activeView.endDate).subtract(1, 'd').format('DD/MM');
    return `Du ${sd} au ${ed}`;
  }

  var getEndDate = (eventRecord) => {
    if (!eventRecord.realDuration) return eventRecord.endDate;
    return new Date(eventRecord.startDate.getTime() + eventRecord.realDuration * 60000);
  }


  /*
  if (props.rooms.length > 1) {
      var items = {};
      props.rooms.map((room, index) => {
          items[index] = {
              weight: 0,
              type: 'button',
              cls: 'btn btn-outline-primary btn-sm btn-calendar-room' + (room.id == props.room.id ? ' active' : ''),
              text: room.name,
              icon: 'fa fa-calendar',
              onClick() {
                  props.roomsToggle(room);
              }
          }
      });
      sidebar.items = items;
  }*/

  //const calendar = useRef(null);
  return (
    <div className={isLoading ? 'data-loading' : ''} style={{ width: '100%', height: '100%' }}>
      {isLoading ? (
        <>
          <div className="b-mask b-widget b-mask-dark b-prevent-transitions">
            <div className="b-mask-content b-drawable" style={{ backgroundColor: '#464646', borderRadius: 10 }}>
              <div id="b-mask-1-maskText" className="b-mask-text">
                <i className="b-mask-icon b-icon b-icon-spinner"></i>
                <div className="b-grid-load-failure">
                  <div className="b-grid-load-fail">Chargement ...</div>
                </div>
              </div>
            </div>
          </div>
          <EmptyBooking opacity={0.3} />
        </>
      ) : null}

      {/*<button onClick={() => refresh()}>REFRESH</button>*/}
      <BryntumCalendar
        key={`room_${props.room.id}`}
        readOnly={true}
        localeManager={{
          locale: 'Fr'
        }}
        locale='Fr'
        ref={ref}
        listeners={{
          dateRangeChange: (data) => props.onDateChange(data.new.startDate),
          activeItemChange: ({ activeItem }) => props.onViewChange(activeItem),
          eventClick: ({ source, domEvent, eventRecord }) => props.onEventClick(eventRecord),
        }}
        tbar={toolbar}
        weekStartDay={1}
        sidebar={sidebar}
        crudManager={{
          autoLoad: true,
          transport: {
            load: {
              url: props.loadUrl ? props.loadUrl : `/api/sportigo/planning?room=${props.room.id}`,
              //url: '/api/sportigo/planning',
              method: 'post',
              timeout: 3000,
            }
          },
          listeners: {
            beforeResponseApply: props.beforeResponseApply ? props.beforeResponseApply : ({ response }) => {
              return response;
            },
            scheduleDblClick: (element) => {
              return false;
            }
            /*
            beforeload: () => {
                setIsLoading(true)
            },
            load: () => {
                setIsLoading(false)
            },*/
          }
        }}
        features={{
          loadOnDemand: true,
          eventTooltip: null,
          eventEdit: null,
          drag: null
        }}
        eventTooltipFeature={null}
        eventEditFeature={null}
        featureEventTooltip={false}
        mode={props.view}
        date={props.date}
        modes={{
          year: false,
          day: props.onViewChange ? {
            dayStartTime: props.room.hourMin,
            dayEndTime: props.room.hourMax,
            hourHeight: 60 * (props.room.scale ? props.room.scale : 1),
            eventRenderer: ({ eventRecord, renderData }) => {
              var di = props.company.disciplines.find(d => d.id === eventRecord.data.resourceId);
              var text = eventRecord.name ? ` ${eventRecord.name} ` : "";
              if (props.rooms.length > 1 && eventRecord.data.roomName) {
                text += ` - ${eventRecord.data.roomName}`;
              }
              //var diName = props.room.coaching ? '' : props.company.disciplines.find(d => d.id === eventRecord.data.resourceId).name;
              return headRenderEvent(eventRecord) + (di ? `<span className="b-event-name">${di.name}</span><br />` : ``) +
                text + props.renderEventInfos(eventRecord, 'Week');
            }
          } : null,
          month: props.onViewChange ? {
            eventRenderer: ({ eventRecord, renderData }) => {
              //if (props.room.coaching) return 'Disponible' + actionEventRender(eventRecord, 'Agenda', props.room, props.reservations);
              //renderData.eventHeight = 'auto';
              var di = props.company.disciplines.find(d => d.id === eventRecord.data.resourceId);
              return `<small>${DateHelper.format(eventRecord.startDate, 'HH:mm')} - ${DateHelper.format(eventRecord.endDate, 'HH:mm')}</small>`;
              //`<p className="agandaDescr"><span>${di.name} ` + (eventRecord.name ? `<br/><span>${eventRecord.name}</span>` : "") + "</span></p>" +

            }
          } : null,
          agenda: {
            enableSticky: true,
            eventHeight: 'auto',
            //range: '1 week',
            range: '15 days',
            //weekStartDay: 1,
            eventFilter: eventFilter(),
            descriptionRenderer: descriptionRender,
            eventRenderer: ({ eventRecord, renderData }) => {
              //if (props.room.coaching) return 'Disponible' + actionEventRender(eventRecord, 'Agenda', props.room, props.reservations);
              //renderData.eventHeight = 'auto';
              var di = props.company.disciplines.find(d => d.id === eventRecord.data.resourceId);
              var text = (di ? di.name : '') + (eventRecord.name ? ` ${eventRecord.name} ` : "");

              if (props.rooms.length > 1 && eventRecord.data.roomName) {
                text += ` - ${eventRecord.data.roomName}`;
              }

              return `<small style='font-weight: bold;'>${DateHelper.format(eventRecord.startDate, 'HH:mm')} - ${DateHelper.format(getEndDate(eventRecord), 'HH:mm')}</small>` + props.renderEventInfos(eventRecord, 'Agenda') +
                `<br/><div class="calendar-text">` + text + '</div>';
            }
          },
          week: props.onViewChange || props.view == 'week' ? {
            //eventLayout: "stack",
            weekStartDay: 1,
            timeFormat: 'HH:mm',
            shortDateTimeFormat: 'HH:mm',
            hourHeight: 60 * (props.room.scale ? props.room.scale : 1),
            dayStartTime: props.room.hourMin,
            dayEndTime: props.room.hourMax,
            visibleStartTime: 10,
            eventHeight: 'auto',
            descriptionRenderer: descriptionRender,
            eventRenderer: ({ eventRecord, renderData }) => {
              var di = props.company.disciplines.find(d => d.id === eventRecord.data.resourceId);
              var text = (di ? di.name : '') + (eventRecord.name ? ` ${eventRecord.name} ` : "");
              if (props.rooms.length > 1 && eventRecord.data.roomName) {
                text += ` - ${eventRecord.data.roomName}`;
              }

              renderData.cls.tokytok = 1;
              renderData.style.color = renderData.eventColor;
              renderData.style.width = "100%!important";

              return `<small style='font-weight: bold;'>${DateHelper.format(eventRecord.startDate, 'HH:mm')} - ${DateHelper.format(getEndDate(eventRecord), 'HH:mm')}</small>` + props.renderEventInfos(eventRecord, 'Agenda') +
                `<br/><div class="calendar-text">` + text + '</div>';

              //var diName = props.room.coaching ? '' : props.company.disciplines.find(d => d.id === eventRecord.data.resourceId).name;
              return `<div className="b-event-header">
                                            <div className="b-event-time">
                                                ${DateHelper.format(eventRecord.startDate, 'HH:mm')} -
                                                ${DateHelper.format(getEndDate(eventRecord), 'HH:mm')}
                                            </div>
                                        </div>
                                        ` + (di ? `<span className="b-event-name">${di.name}</span><br />` : ``) +
                text + props.renderEventInfos(eventRecord, 'Week');
            }
          } : null
        }}
      ></BryntumCalendar>
    </div>
  );
};

export default React.forwardRef(CalendarBryntum);
